import styled from 'styled-components';

import { SWReactCountryIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledCountryShareName = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledCountryIcon = styled(SWReactCountryIcons)`
  width: 19px;
  height: 19px;
  flex-shrink: 0;
`;

export const StyledCountryShareValueCell = styled.span`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 130px;
`;

export const StyledCountrySharePercentage = styled.span`
  ${setFontVariant('report', colorsPalettes.carbon[400])};
`;

export const StyledProgressBar = styled.div<{ progress: string }>`
  width: 34px;
  height: 8px;
  border-radius: 1px;
  background-color: ${colorsPalettes.carbon[50]};
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${({ progress }) => progress};
    background-color: ${colorsPalettes.blue[400]};
  }
`;
